import reqFlashsale from '@/src/requests/flashsale'

export const funcGetOneFlashsale = async (resource, params) => {
  const data = await reqFlashsale.getOne(params.id)
  return { data }
}
